<template>
  <div class="app-container">
    <NavBar 
      @getPageName="getPageName"
    />
    
    <div v-if="showPage == 'about'">
      <AboutModal 
        @close="getPageName('map')"
      />
    </div>
    <div class="content-container">
      <SidePanel
        @getSoilProperty="getSoilProperty"
        @getSearchCoords="getSearchCoords"
        @getDrawEnabled="getDrawEnabled"
      />
      <div class="map-and-legend-container">
        <div class="map-container">
          <SoilMap
            :mapCenterCoords="mapCenterCoords"
            :selectedSoilProperty="selectedSoilProperty"
            :drawEnabled="drawEnabled"
          />
        </div>
        <LegendPanel :soilProperty="selectedSoilProperty"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import SoilMap from '@/components/SoilMap.vue';
import SidePanel from '@/components/SidePanel.vue';
import LegendPanel from '@/components/LegendPanel.vue';
import NavBar from '@/components/NavBar.vue';
import AboutModal from '@/components/AboutModal.vue';


const selectedSoilProperty = ref('soc');
const mapCenterCoords = ref([28.45, -85.6]);
const drawEnabled = ref(false);
const showPage = ref('map');

const getSoilProperty = (value) => {
  selectedSoilProperty.value = value;
};

const getSearchCoords = (value) => {
  mapCenterCoords.value = value;
};

const getDrawEnabled = (value) => {
  drawEnabled.value = value;
};

const getPageName = (value) => {
  showPage.value = value;
};


</script>
<style scoped>
/* Root container to ensure full viewport height */
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden; /* Prevent scroll */
}

/* Flex container for the app layout */
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh; /* Full height of the viewport */
}

/* Ensure content container grows to fill the remaining space */
.content-container {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  max-height: 100vh;
}

/* Layout for map and legend container */
.map-and-legend-container {
  display: flex;
  flex-grow: 1;
  overflow: hidden;
}

/* Map container should grow and fill the remaining space */
.map-container {
  flex-grow: 1;
  position: relative;
  height: 100%;
  overflow: hidden; /* Prevent overflow from causing scroll */
}
</style>
